import React from 'react';
import { formatPrice, SelectedPlan } from '../../data/pricingPlans';
type PlanSummaryBarProps = {
  plan: SelectedPlan | null;
  onChangePlan?: () => void;
};
export function PlanSummaryBar({
  plan,
  onChangePlan
}: PlanSummaryBarProps) {
  if (!plan) return null;
  return <div className="mt-5 flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1 rounded-lg border border-[#A6B6F8]/60 bg-[#A6B6F8]/15 px-3.5 py-2.5" data-id="element-273" data-mp="2g8nlh66gq54p">
      <p className="text-xs leading-5 text-[#3A3A3A]" data-id="element-274" data-mp="33yrobbbtu0un">
        <span className="font-bold text-[#041F60]" data-id="element-275" data-mp="38x1mzvwrfjl0">{plan.name}</span> ·{' '}
        {formatPrice(plan.price)} / month
        {plan.discountLabel && <span className="font-semibold text-[#5B5299]" data-id="element-276" data-mp="2tzspslkrzlld">
            {' '}
            · {plan.discountLabel} {plan.discountPercent}% off
          </span>}
      </p>
      {onChangePlan && <button type="button" onClick={onChangePlan} className="text-xs font-bold text-[#5B5299] underline decoration-[#A6B6F8] underline-offset-4 transition-colors duration-150 hover:text-[#041F60] focus:text-[#041F60] focus:outline-none" data-id="element-277" data-mp="1ijkk4ba1ru5h">
          Change plan
        </button>}
    </div>;
}